import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import welcomeImage from 'src/img/welcome-bg.png';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  actions: {
    marginTop: '22px',
    '& .MuiButton-root': {
      width: '100%'
    }
  },
  welcomeBlock: {
    marginBottom: '20px',
    backgroundImage: "url(".concat(welcomeImage, ")"),
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center bottom',
    backgroundSize: 'cover'
  },
  contentWrapper: {
    padding: '40px 60px',
    background: 'linear-gradient(90deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)',
    boxShadow: palette.shadows.light
  },
  content: {
    maxWidth: '60%'
  }
}));
export default useStyles;